import { render, staticRenderFns } from "./MobileReviews.vue?vue&type=template&id=0f68443c&scoped=true&"
import script from "./MobileReviews.vue?vue&type=script&lang=js&"
export * from "./MobileReviews.vue?vue&type=script&lang=js&"
import style0 from "./MobileReviews.vue?vue&type=style&index=0&id=0f68443c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68443c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CollectionReview: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/CollectionReview.vue').default})
